import _slicedToArray from "/builds/timeneye/panel-front-end/node_modules/@babel/runtime-corejs2/helpers/slicedToArray.js";
import "core-js/modules/es6.function.name.js";
import "core-js/modules/es6.object.keys.js";
import Vue from 'vue';
import { isSSR, fromSSR, client } from "./Platform.js";
import { listenOpts, noop } from "../utils/event.js";
import debounce from "../utils/debounce.js";
var SIZE_LIST = ['sm', 'md', 'lg', 'xl'];
var passive = listenOpts.passive;
export default {
  width: 0,
  height: 0,
  name: 'xs',
  sizes: {
    sm: 600,
    md: 1024,
    lg: 1440,
    xl: 1920
  },
  lt: {
    sm: true,
    md: true,
    lg: true,
    xl: true
  },
  gt: {
    xs: false,
    sm: false,
    md: false,
    lg: false
  },
  xs: true,
  sm: false,
  md: false,
  lg: false,
  xl: false,
  setSizes: noop,
  setDebounce: noop,
  install: function install($q, queues, cfg) {
    var _this = this;

    if (isSSR === true) {
      $q.screen = this;
      return;
    }

    var _window = window,
        visualViewport = _window.visualViewport;
    var target = visualViewport || window;
    var scrollingElement = document.scrollingElement || document.documentElement;
    var getSize = visualViewport === void 0 || client.is.mobile === true ? function () {
      return [Math.max(window.innerWidth, scrollingElement.clientWidth), Math.max(window.innerHeight, scrollingElement.clientHeight)];
    } : function () {
      return [visualViewport.width * visualViewport.scale + window.innerWidth - scrollingElement.clientWidth, visualViewport.height * visualViewport.scale + window.innerHeight - scrollingElement.clientHeight];
    };
    var classes = cfg.screen !== void 0 && cfg.screen.bodyClasses === true;

    var update = function update(force) {
      var _getSize = getSize(),
          _getSize2 = _slicedToArray(_getSize, 2),
          w = _getSize2[0],
          h = _getSize2[1];

      if (h !== _this.height) {
        _this.height = h;
      }

      if (w !== _this.width) {
        _this.width = w;
      } else if (force !== true) {
        return;
      }

      var s = _this.sizes;
      _this.gt.xs = w >= s.sm;
      _this.gt.sm = w >= s.md;
      _this.gt.md = w >= s.lg;
      _this.gt.lg = w >= s.xl;
      _this.lt.sm = w < s.sm;
      _this.lt.md = w < s.md;
      _this.lt.lg = w < s.lg;
      _this.lt.xl = w < s.xl;
      _this.xs = _this.lt.sm;
      _this.sm = _this.gt.xs === true && _this.lt.md === true;
      _this.md = _this.gt.sm === true && _this.lt.lg === true;
      _this.lg = _this.gt.md === true && _this.lt.xl === true;
      _this.xl = _this.gt.lg;
      s = _this.xs === true && 'xs' || _this.sm === true && 'sm' || _this.md === true && 'md' || _this.lg === true && 'lg' || 'xl';

      if (s !== _this.name) {
        if (classes === true) {
          document.body.classList.remove("screen--".concat(_this.name));
          document.body.classList.add("screen--".concat(s));
        }

        _this.name = s;
      }
    };

    var updateEvt,
        updateSizes = {},
        updateDebounce = 16;

    this.setSizes = function (sizes) {
      SIZE_LIST.forEach(function (name) {
        if (sizes[name] !== void 0) {
          updateSizes[name] = sizes[name];
        }
      });
    };

    this.setDebounce = function (deb) {
      updateDebounce = deb;
    };

    var start = function start() {
      var style = getComputedStyle(document.body); // if css props available

      if (style.getPropertyValue('--q-size-sm')) {
        SIZE_LIST.forEach(function (name) {
          _this.sizes[name] = parseInt(style.getPropertyValue("--q-size-".concat(name)), 10);
        });
      }

      _this.setSizes = function (sizes) {
        SIZE_LIST.forEach(function (name) {
          if (sizes[name]) {
            _this.sizes[name] = sizes[name];
          }
        });
        update(true);
      };

      _this.setDebounce = function (delay) {
        updateEvt !== void 0 && target.removeEventListener('resize', updateEvt, passive);
        updateEvt = delay > 0 ? debounce(update, delay) : update;
        target.addEventListener('resize', updateEvt, passive);
      };

      _this.setDebounce(updateDebounce);

      if (Object.keys(updateSizes).length > 0) {
        _this.setSizes(updateSizes);

        updateSizes = void 0; // free up memory
      } else {
        update();
      } // due to optimizations, this would be left out otherwise


      classes === true && _this.name === 'xs' && document.body.classList.add("screen--xs");
    };

    if (fromSSR === true) {
      queues.takeover.push(start);
    } else {
      start();
    }

    Vue.util.defineReactive($q, 'screen', this);
  }
};